import { render, staticRenderFns } from "./ManterReuFederal.vue?vue&type=template&id=2fbcc3d6&scoped=true&"
import script from "./ManterReuFederal.vue?vue&type=script&lang=js&"
export * from "./ManterReuFederal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbcc3d6",
  null
  
)

export default component.exports